exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-all-memes-js": () => import("./../../../src/templates/AllMemes.js" /* webpackChunkName: "component---src-templates-all-memes-js" */),
  "component---src-templates-category-page-js": () => import("./../../../src/templates/CategoryPage.js" /* webpackChunkName: "component---src-templates-category-page-js" */),
  "component---src-templates-meme-page-js": () => import("./../../../src/templates/MemePage.js" /* webpackChunkName: "component---src-templates-meme-page-js" */)
}

